import React from 'react';
import { ScenarioDecision } from '@/types';
import { HelpOutline, AccessTime, KeyboardArrowDown } from '@mui/icons-material';

interface DecisionModalProps {
    decision: ScenarioDecision | null;
    onChoose: (optionId: string, timeCostSeconds: number) => void;
    onMinimize: () => void;
    disabled: boolean;
}

const DecisionModal: React.FC<DecisionModalProps> = ({ decision, onChoose, onMinimize, disabled }) => {
    if (!decision) return null;

    return (
        <div className="fixed bottom-6 right-6 z-[1400] w-[420px] max-w-[calc(100vw-3rem)] bg-slate-800 border border-blue-500/30 rounded-2xl shadow-2xl shadow-blue-500/10 animate-fade-in">
            <div className="p-5">
                <div className="flex items-start gap-3 mb-4">
                    <div className="p-2 bg-blue-500/20 rounded-lg shrink-0 mt-0.5">
                        <HelpOutline className="text-blue-400" fontSize="small" />
                    </div>
                    <div className="flex-1">
                        <p className="text-[10px] font-bold text-blue-400 uppercase tracking-widest mb-1">Decision Required</p>
                        <p className="text-white font-medium text-sm leading-relaxed">{decision.prompt}</p>
                    </div>
                    <button
                        onClick={onMinimize}
                        className="p-1.5 rounded-lg hover:bg-slate-700 transition-colors text-slate-400 hover:text-white shrink-0"
                        title="Minimize — decide later"
                    >
                        <KeyboardArrowDown fontSize="small" />
                    </button>
                </div>
                <div className="grid grid-cols-1 gap-2">
                    {decision.options.map((option) => (
                        <button
                            key={option.id}
                            onClick={() => onChoose(option.id, option.timeCostSeconds)}
                            disabled={disabled}
                            className="text-left p-3 rounded-lg border border-slate-600 bg-slate-900 hover:bg-slate-700 hover:border-blue-500/50 transition-all group disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <div className="flex items-center justify-between gap-3">
                                <p className="text-sm text-slate-300 group-hover:text-white transition-colors leading-snug">{option.text}</p>
                                <div className="flex items-center gap-1 text-slate-500 group-hover:text-slate-400 shrink-0">
                                    <AccessTime sx={{ fontSize: 12 }} />
                                    <span className="text-[10px] font-medium">{Math.floor(option.timeCostSeconds / 60)}m</span>
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DecisionModal;
